export default __webpack_public_path__ + "static/media/foto_10.1aea3ad8.jpg";